import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModelAdvisor } from "wint-api-client/dist/types";

function useDocumentationLogService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getDocumentationLogEntries = async (companyId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .DocumentationLogClient.GetAll(companyId)
      .then((res) => res.data);
  };

  const createLog = (log: WintSuperkollAPIModelAdvisor.DocumentationLogItemPost): Promise<string> => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .DocumentationLogClient.Create(log)
      .then((res) => res.data);
  };

  const getAttachment = async (logId: string, attachmentId: string): Promise<string | undefined> => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .DocumentationLogClient.GetAttachmentAsync(logId, attachmentId)
      .then((res) => res.data.data);
  };

  const downloadAttachment = (logId: string, attachmentId: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    }).DocumentationLogClient.DownloadAttachmentAsync(logId, attachmentId);
  };

  return { getDocumentationLogEntries, createLog, getAttachment, downloadAttachment };
}

export default useDocumentationLogService;
